<template>
  <van-popup
    :show="show"
    position="bottom"
    round
    :style="{ height: '70vh' }"
    closeable
    safe-area-inset-bottom
    @update:show="$emit('update:show', $event)"
  >
    <section class="agreement-drawer">
      <header><span class="eyebrow">LEGAL</span><h2>{{ agreement?.title || fallbackTitle }}</h2></header>
      <div v-if="loading" class="drawer-state"><van-loading color="#31d8c7" />正在加载协议</div>
      <div v-else-if="error" class="drawer-state"><p>协议加载失败</p><button @click="$emit('retry')">重新加载</button></div>
      <article v-else class="agreement-content" v-html="agreement?.content || '暂无协议内容'"></article>
    </section>
  </van-popup>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  show: Boolean,
  type: { type: String, default: 'USER_AGREEMENT' },
  agreement: { type: Object, default: null },
  loading: Boolean,
  error: Boolean
})
defineEmits(['update:show', 'retry'])

const fallbackTitle = computed(() => (props.type === 'PRIVATE_POLICY' ? '隐私政策' : '用户协议'))
</script>

<style scoped>
.agreement-drawer { height: 100%; display: flex; flex-direction: column; padding: 24px 20px calc(18px + env(safe-area-inset-bottom)); color: #173046; background: #f5f8fa; }
.agreement-drawer header { flex: none; padding: 0 36px 14px 0; border-bottom: 1px solid #dce4e9; }
.eyebrow { color: #179b90; font-size: 10px; font-weight: 800; }
.agreement-drawer h2 { margin-top: 4px; color: #0a1e2e; font-size: 20px; }
.agreement-content { flex: 1; overflow-y: auto; padding: 18px 2px 24px; color: #40586b; font-size: 14px; line-height: 1.85; word-break: break-word; }
.agreement-content :deep(h1), .agreement-content :deep(h2), .agreement-content :deep(h3) { margin: 18px 0 8px; color: #10293d; font-size: 16px; }
.agreement-content :deep(p) { margin-bottom: 12px; }
.drawer-state { flex: 1; display: grid; place-content: center; justify-items: center; gap: 14px; color: #7890a3; font-size: 14px; }
.drawer-state button { padding: 9px 18px; border-radius: 6px; color: #07231f; background: var(--cyan); font-weight: 700; }
</style>
